import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { getCachedValue, LocalStorageKeys } from '@shared-utils';
import { Bmi, BmiApi, Notifications } from '@types-lib';
import { SnackNotificationsDialogService } from '@ui-lib/services';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { catchError, Observable } from 'rxjs';

export class GetUserBodyMassIndexInfoEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);
  private snackBar = inject(SnackNotificationsDialogService);

  private biometricsListLength =
    getCachedValue(LocalStorageKeys.PIMS_PARAMETERS)?.pimsVisitParameters?.biometrics?.listLength || 300;

  get(req: Bmi.LoadBmiDataReq): Observable<BmiApi.UserBiometricsResponse> {
    const serviceCodesAsString: string =
      req.serviceCodesFilter?.reduce((acc, serviceCode) => (acc ? `${acc},${serviceCode}` : serviceCode), '') || '';

    const queryParams: BmiApi.UserBiometricsQueryParams = {
      user_id: req.userId,
      limit: req.limit || this.biometricsListLength,
      order: req.order || 'desc',
      service_codes: serviceCodesAsString,
      offset: req.offset || 0,
      ...(req.visitId && { order_id: req.visitId }),
    };

    return this.http
      .get<BmiApi.UserBiometricsResponse>(`${this.env.constants.ADMIN_API_URL}/admin/orders/bodymassindex`, {
        params: { ...queryParams },
      })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error(err);
          this.snackBar.openErrorMessage(Notifications.generic.failure);
          throw err;
        }),
      );
  }
}
